module.exports = __webpack_public_path__ + "media/shared/images/tolo_logotype-aaed0f79d2d657da6f32389e4fc76a1a.svg";